import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import ThemeManager from './ThemeManager';
import ActivityManager from './ActivityManager';
import ThemeStatusTypes from './ThemeStatusTypes';

class ThemeStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return null;
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.THEME_STORE_ALL:
        ThemeManager.all(action.collectionId);
        return this.getInitialState();

      case ActionTypes.THEME_STORE_ALL_COMPLETE:
        return action.themes;

      case ActionTypes.THEME_STORE_FIND:
        ThemeManager.find(action.collectionId, action.themeId);
        return this.getInitialState();

      case ActionTypes.THEME_STORE_FIND_COMPLETE:
        ActivityManager.saveActivity({
          theme_id: action.theme.id,
          collection_id: action.theme.collectionId,
          event_type: ThemeStatusTypes.THEME_STATUS_STARTED,
        });
        return action.theme;

      case ActionTypes.THEME_STORE_COMPLETE:
        ActivityManager.saveActivity({
          theme_id: action.themeId,
          collection_id: action.collectionId,
          event_type: ThemeStatusTypes.THEME_STATUS_COMPLETED,
        });
        return state;

      case ActionTypes.ACTIVITY_SAVED:
        return {
          ...state,
          status: action.activity.event_type,
          statusDate: action.activity.updated_at,
        };

      case ActionTypes.THEME_STORE_CHAPTER_ENTER:
        ActivityManager.saveActivityLog({
          path: 'theme-chapter-activities',
          params: {
            chapter_id: action.chapterId,
            theme_id: action.themeId,
            event_type: ThemeStatusTypes.THEME_STATUS_CHAPTER_VIEWED
          }
        });
        return state;

      default:
        return state;
    }
  }
}

export default new ThemeStore();
